import { X } from "lucide-react";

const Card = ({ 
    index, 
    fields, 
    onRemove, 
    register, 
    errors, 
    groupName
}) => {
    // 檢查是否為需要數字驗證的欄位
    const isNumberField = (fieldName, groupName) => {
        return (
            (groupName === 'financials_highlights' && ['num_lead_investors', 'num_investors', 'num_funding_rounds'].includes(fieldName))
        );
    };

    return (
    <div className="border rounded-lg px-4 py-3.5 bg-white shadow-sm relative h-fit">
            <button
                type="button"
                onClick={onRemove}
                className="border border-red-500 bg-red-500 text-white hover:bg-red-600 rounded-full p-1 absolute -top-3 end-3 font-bold"
            >
                <X size={18} />
            </button>
            
            <div className="space-y-4">
                {fields.map(field => {
                    const fieldPath = `${groupName}.${index}.${field.name}`;
                    const error = errors?.[groupName]?.[index]?.[field.name];

                    // 如果是 boolean 類型，渲染 checkbox
                    if (field.type === 'boolean') {
                        return (
                            <div key={field.name} className="space-y-1">
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        {...register(fieldPath)}
                                        className={`h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500 ${
                                            error ? 'border-red-500' : ''
                                        }`}
                                    />
                                    <span className="text-sm font-medium">{field.label}</span>
                                </label>
                                {error && (
                                    <p className="text-red-500 text-sm">{error.message}</p>
                                )}
                            </div>
                        );
                    }

                    // 一般文字欄位
                    return (
                        <div key={field.name} className="space-y-1">
                            <label className="block text-sm font-medium">{field.label}
                                <span className="text-red-500 ml-1">*</span>
                            </label>
                            <input
                                {...register(fieldPath, {
                                    ...(isNumberField(field.name, groupName) && {
                                        pattern: {
                                            value: /^\d*$/,
                                            message: '請輸入有效的數字'
                                        }
                                    })
                                })}
                                className={`w-full p-2 border rounded ${
                                    error ? 'border-red-500' : 'border-gray-300'
                                }`}
                            />
                            {error && (
                                <p className="text-red-500 text-sm">{error.message}</p>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Card;